import $ from 'jquery';
$(".js-offcanvas-toggle").on("click", function () {
    $(".c-offcanvas").toggleClass("is-active");
});
